/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios';

export default {
  API: {
    // http://localhost/studio/#/autoQA/aiEvaluationSummary/?host=c1-wysdom.wysdom.calabrio.dev&sid=HZ5A442D2529B44ABF8F350BEA4E4DC093&options=
    // INTERACTIONS_CHAT_FILTERS: '/interactionsAnalytics/chatFilters',
    INTERACTIONS_CHAT_FILTERS: '/autoQA/chatFilters',
    AUTO_QA_EVAL_FORM: '/autoQA/autoQAEvalResult',
    AUTO_QA_EVAL_FORM_DROPDOWN: '/autoQA/formFilter',
    AUTO_QA_EVAL_DATA_INSIGHT_SCORES: '/autoQA/autoQAEvalDataInsightScores',
    BES_BAS_CONTACT_REASONS_SUMMARY: '/homeDashboard/botBesBasForContactReasons',
    AUTO_QA_PERFORMANCE_SCORES: '/autoQA/autoQAEvalPerformanceScores',
    AUTO_QA_SUMMARY_PANEL: '/autoQA/summaryPanel',
    AUTO_QA_LINE_CHART: '/autoQA/autoEvalScoreLineChart',
    AUTO_QA_BAR_CHART: '/autoQA/autoEvalSectionScoreBarChart',
    AUTO_QA_EVAL_GROUP_TEAM_BAR_CHART: '/autoQA/autoQAEvalGroupTeamsBarChart',
    AUTO_QA_EVAL_PAGE_FILTERS: '/autoQA/evalPageFilters',
    AUTO_QA_EVAL_GROUP_TEAM_TABLE_SUMMARY: '/autoQA/autoQAEvalGroupTeamTableSummary',
    AUTO_QA_EVAL_AGENT_TABLE_SUMMARY: '/autoQA/autoQAEvalAgentTableSummary',
    AUTO_QA_EVAL_GROUPS_TEAMS_LINE_CHART: '/autoQA/autoQAEvalGroupTeamsLineChart',
    AUTO_QA_EVAL_FORM_OVERRIDE: '/autoQA/autoQAEvalResultOverride',
    AUTO_QA_EVAL_FORM_LIST: '/autoQA/autoQAEvalFormList', // form manager
    AUTO_QA_EVAL_DELETE_FORM: '/autoQA/autoQAEvalDeleteForm',
    AUTO_QA_EVAL_CLONE_FORM: '/autoQA/autoQAEvalCloneForm',
    AUTO_QA_EVAL_ARCHIVE_FORM: '/autoQA/autoQAEvalArchiveForm',
    AUTO_QA_EVAL_QUESTION_LIST: '/autoQA/autoQAEvalQuestionList',
    AUTO_QA_EVAL_FORM_GET_FORM_BY_ID: '/autoQA/autoQAEvalForm',
    AUTO_QA_EVAL_UPDATE_FORM: '/autoQA/autoQAEvalFormEdit',
    AUTO_QA_EVAL_PUBLISH_FORM: '/autoQA/autoQAEvalPublishForm',
    AUTO_QA_EVAL_FORM_LOCK: '/autoQA/autoQAEvalFormLock',
    AUTO_QA_EVAL_FORM_UNLOCK: '/autoQA/autoQAEvalFormUnlock',

    AUTO_QA_EVAL_CUSTOM_QUESTION_LIST: '/autoQA/autoQAEvalCustomQuestionList', // question manager
    AUTO_QA_EVAL_DELETE_QUESTION: '/autoQA/autoQAEvalDeleteCustomQuestion',
    AUTO_QA_EVAL_CLONE_QUESTION: '/autoQA/autoQAEvalCloneCustomQuestion',
    AUTO_QA_EVAL_ARCHIVE_QUESTION: '/autoQA/autoQAEvalArchiveCustomQuestion',
    AUTO_QA_EVAL_FORM_GET_QUESTION_BY_ID: '/autoQA/autoQAEvalCustomQuestion',
    AUTO_QA_EVAL_UPDATE_QUESTION: '/autoQA/autoQAEvalCustomQuestionEdit',
    AUTO_QA_EVAL_PUBLISH_QUESTION: '/autoQA/autoQAEvalPublishCustomQuestion',
    AUTO_QA_EVAL_QUESTION_LOCK: '/autoQA/autoQAEvalCustomQuestionLock',
    AUTO_QA_EVAL_QUESTION_UNLOCK: '/autoQA/autoQAEvalCustomQuestionUnlock',
    AUTO_QA_METADATA_LIST: '/autoQA/autoQAMetadataList',

    INTERACTIONS_TOPIC_GROUP: '/interactionsAnalytics/topicGroup',
    SMART_TAG_DATA_ON_MEDIA_PLAYER: '/smartTags/smartTagMediaPlayerAITags',
  },

  cachedHash: {},
  cancelTokens: [],

  mockSmartTagsDataOnMediaPlayer: {
    data: [
      {
        key: 'blackFridayDeals',
        label: 'Black Friday Deals',
        sent_by: 'agent',
        categories:['sales', 'promotions']
      }, {
        key: 'discountRequests',
        label: 'Discount Requests During Checkout',
        sent_by: 'agent',
        categories:['sales']
      }, {
        key: 'shippingDelayInquiries',
        label: 'Shipping Delay Inquiries from Customers',
        sent_by: 'customer',
        categories:['sales', 'shipping']
      }, {
        key: 'limitedEdition',
        label: 'Limited Edition',
        sent_by: 'agent',
        categories:['promotions']
      },
      {
        key: 'limitedEditionAgent',
        label: 'Limited Edition Agent',
        sent_by: 'both',
        categories:['sales', 'promotions']
      },
      {
        key: 'limitedEditionCustomer',
        label: 'Limited Edition Customer',
        sent_by: 'customer',
        categories:['sales', 'promotions']
      }
    ]
  },

  getRequest(authUser, url, headers) {
    if (authUser.accessToken) {
      if (headers == null) headers = {};
      headers['Authorization'] = 'Bearer ' + authUser.accessToken;
      headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      return axios.get(url, { headers: headers, timeout: 300000 });
    } else {
      return null;
    }
  },

  postRequest(authUser, url, payload, headers) {
    if (authUser.accessToken) {
      if (headers == null) headers = {};
      headers['Authorization'] = 'Bearer ' + authUser.accessToken;
      headers['Api-Configs'] = JSON.stringify(authUser.config.api.configs);
      if(authUser.sessionId) {
        headers['Auth-Host'] = authUser.authHost || "";
        headers['Auth-Session-Id'] = authUser.sessionId;
        headers['Auth-Product-Name'] = authUser.productName || "";
        headers['Auth-Options'] = authUser.authOptions || "";
      }

      let cancelTokenKey = url;
      if (this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token,
      };

      return axios.post(url, payload, options);
    } else {
      return null;
    }
  },

  fetchChatFilters(authUser) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.INTERACTIONS_CHAT_FILTERS;
    return this.getRequest(authUser, url);
  },

  fetchAutoQAEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAEvalQuestionList(authUser) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_QUESTION_LIST;
    return this.getRequest(authUser, url);
  },

  fetchAutoQAEvalFormById(authUser, formId) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_GET_FORM_BY_ID + '?formId=' + formId;
    return this.getRequest(authUser, url);
  },

  fetchAutoQAEvalFormDropdown(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_DROPDOWN;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAEvalDataInsightScoresData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_DATA_INSIGHT_SCORES;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAEvalTopicGroupData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.INTERACTIONS_TOPIC_GROUP;
    return this.postRequest(authUser, url, payload);
  },

  fetchSmartTagsDataOnMediaPlayer(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.SMART_TAG_DATA_ON_MEDIA_PLAYER;
    // return this.mockSmartTagsDataOnMediaPlayer;
    return this.postRequest(authUser, url, payload);
  },

  fetchBesBasContactReasonsSummary(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.BES_BAS_CONTACT_REASONS_SUMMARY;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAPerformanceScores(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_PERFORMANCE_SCORES;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQASummaryPanel(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_SUMMARY_PANEL;
    return this.postRequest(authUser, url, payload);
  },
  fetchAutoQALineChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_LINE_CHART;
    return this.postRequest(authUser, url, payload);
  },
  fetchAutoQABarChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_BAR_CHART;
    return this.postRequest(authUser, url, payload);
  },
  fetchAutoQAEvalGroupTeamLineChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_EVAL_GROUPS_TEAMS_LINE_CHART;
    return this.postRequest(authUser, url, payload);
  },
  saveAutoQAEvalFormOverride(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_OVERRIDE;
    return this.postRequest(authUser, url, payload);
  },
  fetchAutoQAEvalGroupTeamBarChart(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_EVAL_GROUP_TEAM_BAR_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAEvalGroupTeamTableSummary(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_EVAL_GROUP_TEAM_TABLE_SUMMARY;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAEvalAgentTableSummary(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_EVAL_AGENT_TABLE_SUMMARY;
    return this.postRequest(authUser, url, payload);
  },
  
  fetchAutoQAEvalPageFilters(authUser, payload) {
    let url = Vue.WyConstants.SERVER.ANALYTICS_HOST + this.API.AUTO_QA_EVAL_PAGE_FILTERS;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoEvalFormList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_LIST;
    return this.postRequest(authUser, url, payload);
  },
  deleteAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_DELETE_FORM;
    return this.postRequest(authUser, url, payload);
  },
  cloneAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_CLONE_FORM;
    return this.postRequest(authUser, url, payload);
  },
  archiveAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_ARCHIVE_FORM;
    return this.postRequest(authUser, url, payload);
  },
  updateAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_UPDATE_FORM;
    return this.postRequest(authUser, url, payload);
  },
  publishAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_PUBLISH_FORM;
    return this.postRequest(authUser, url, payload);
  },
  lockAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_LOCK;
    return this.postRequest(authUser, url, payload);
  },
  unlockAutoEvalForm(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_UNLOCK;
    return this.postRequest(authUser, url, payload);
  },

  fetchAutoQAEvalQuestionById(authUser, questionId) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_FORM_GET_QUESTION_BY_ID + '?questionId=' + questionId;
    return this.getRequest(authUser, url);
  },
  fetchAutoCustomEvalQuestionList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_CUSTOM_QUESTION_LIST;
    return this.postRequest(authUser, url, payload);
  },
  fetchAutoQAMetadataList(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_METADATA_LIST;
    return this.getRequest(authUser, url, payload);
  },
  deleteAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_DELETE_QUESTION;
    return this.postRequest(authUser, url, payload);
  },
  cloneAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_CLONE_QUESTION;
    return this.postRequest(authUser, url, payload);
  },
  archiveAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_ARCHIVE_QUESTION;
    return this.postRequest(authUser, url, payload);
  },
  updateAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_UPDATE_QUESTION;
    return this.postRequest(authUser, url, payload);
  },
  publishAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_PUBLISH_QUESTION;
    return this.postRequest(authUser, url, payload);
  },
  lockAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_QUESTION_LOCK;
    return this.postRequest(authUser, url, payload);
  },
  unlockAutoEvalQuestion(authUser, payload) {
    let url = Vue.WyConstants.SERVER.INTERACTIONS_HOST + this.API.AUTO_QA_EVAL_QUESTION_UNLOCK;
    return this.postRequest(authUser, url, payload);
  },
};
